import styled from "styled-components";
import { StyledStoreButtonBaseProps } from "../StoreButtonBase.types";

const StyledStoreButtonBase = styled.button<StyledStoreButtonBaseProps>`
	display: flex;
	align-items: center;
	justify-content: center;
	transition: background-color 300ms ease-in-out;
	cursor: pointer;

	${({ theme }) => {
		const COLOR_BG_BLACK = theme.palette.hexFor("black");
		const COLOR_FG_LIGHT_1 = theme.palette.hexForRole("fg_light_1");
		const COLOR_FG_LIGHT_3 = theme.palette.hexForRole("fg_light_3");
		const COLOR_CTA_DISABLED = theme.palette.hexForRole("cta_disabled");
		const COLOR_NEUTRAL_400 = theme.palette.hexFor("neutral_400");
		const COLOR_NEUTRAL_700 = theme.palette.hexFor("neutral_700");
		const COLOR_NEUTRAL_900 = theme.palette.hexFor("neutral_900");
		return {
			height: theme.space.xxl,
			padding: theme.space.xs,
			backgroundColor: COLOR_BG_BLACK,
			color: COLOR_FG_LIGHT_1,
			border: `1px solid ${COLOR_FG_LIGHT_3}`,
			borderRadius: theme.radii.xs,
			":hover": {
				backgroundColor: COLOR_NEUTRAL_700,
			},
			":active": {
				backgroundColor: COLOR_NEUTRAL_900,
			},
			":disabled": {
				color: COLOR_NEUTRAL_400,
				backgroundColor: COLOR_CTA_DISABLED,
				svg: {
					fill: COLOR_NEUTRAL_400,
				},
			},
			svg: {
				fill: COLOR_FG_LIGHT_1,
			},
		};
	}}
`;

export default StyledStoreButtonBase;
